/*
 * GENERATED FILE — do not edit by hand.
 * Built from the ClientSlugs.csv export the team provided, 2026-09-18, 479 clients.
 *
 * A client's webplayer handle is stored and editable from their dashboard, and the rule that generated
 * it changed on 2026-06-29, so it cannot be derived from the client id and name. Until a resolver serves
 * these, the lite pages read them from here, and a handle edited after the date above opens the wrong
 * page. A client that is missing here gets a disabled button, never a guessed URL.
 *
 * From the 500 exported rows, 8 were dropped for a non-positive id or an
 * empty slug (test and backup streams), and 13 were a second handle for a client that
 * already had one, where the first was kept. Those repeats are test accounts (112, 123, 1075) except
 * client 47: 'shm' is its main stream and 'SHMShireinuProject' a second one, so an event of that client
 * streamed on the second handle links to the wrong page.
 *
 * Custom domains are not in the export, so a client on one gets a livecontrol.tv link instead of theirs.
 */

/*
 * SWAP POINT: both Command Center environments talk to the production API, so this is not derived from
 * environment.production — a staging base would give dead links for real slugs.
 */
export const WEBPLAYER_BASE_URI = 'https://{slug}.livecontrol.tv';

export const WEBPLAYER_HANDLES_GENERATED_ON = '2026-09-18';

/** LiveControl client id (cid) to webplayer slug. */
export const WEBPLAYER_SLUGS: Record<number, string> = {
  5: 'hunter-test-v2',
  6: 'ddt-test-v2',
  8: 'judea',
  10: 'wbt',
  16: 'tdhs',
  17: 'tbesoc',
  18: 'coa',
  23: 'tba',
  24: 'david-crohon',
  25: 'tbe',
  36: 'tst',
  39: 'shaaray',
  40: 'crs',
  47: 'shm',
  51: 'etz-chaim',
  53: 'koldorot',
  57: 'emanuelsf',
  58: 'templeemanu-el',
  59: 'adat-shalom',
  60: 'adath-israel',
  62: 'congbethel',
  63: 'tisbny',
  64: 'beth-ahabah',
  66: 'dix-hills',
  67: 'ncjc',
  75: 'beth-israel-center',
  77: 'kolamireform',
  83: 'village-temple',
  84: 'beth-shalom',
  93: 'congregation-emanuel',
  96: 'har-shalom',
  98: 'or-hadash',
  99: 'sinaisrq',
  100: 'park-hill',
  101: 'emanuel-ws',
  104: 'micah',
  107: 'beth-am',
  112: 'test-4',
  114: 'tbt',
  115: 'bnai-israel',
  116: 'dev',
  117: 'bnai-tikvah',
  119: 'pnp',
  123: 'dev-2',
  162: 'thepointechurch',
  185: 'BOLCOH',
  190: 'Philippi',
  198: 'gomz',
  213: 'VintageChurchLA',
  217: 'stdave',
  221: 'thetransparentchurch',
  222: 'templeshalom',
  223: 'MonmouthReformTemple',
  230: 'foothills',
  233: 'FBCBrandon',
  235: 'hopefortulsa',
  237: 'LWCC',
  238: 'bayside',
  239: 'dcc',
  248: 'tbanj',
  249: 'lvnertamid',
  253: 'aliveinchrist',
  258: 'Abundantlife',
  259: 'ardent',
  261: 'livewellchurch',
  270: 'BHC',
  274: 'PowerforAbundantRecovery',
  1007: 'ddt-testing',
  1013: 'betheloxnard',
  1015: 'ISM',
  1016: '1016-SmartDelta',
  1020: '1020-LiveControl-Announcements',
  1021: 'stmarkhsv',
  1022: 'stjoeparish',
  1025: 'WFCOG',
  1026: '1026-Marlow-Heights-Church',
  1028: 'RHCTN',
  1029: 'fmhpc',
  1030: 'myvillage',
  1031: 'bethemet',
  1032: 'unionflint',
  1033: 'congregation_test',
  1034: 'ops-test',
  1035: 'capitoland',
  1036: 'hillside',
  1038: 'memphistabernacle',
  1039: 'Ezekielbc',
  1040: 'hillside-memorial',
  1041: 'TLC',
  1042: 'rishi',
  1043: 'goodnewschurch',
  1044: 'sandbox',
  1046: 'emmanuellutheranchurch',
  1049: 'upumc',
  1050: 'tinw',
  1054: 'epiphanylutheran',
  1055: 'cary-test-account',
  1056: 'jccofharrison',
  1057: 'vineyardjackson',
  1061: 'theparrish',
  1062: 'brentwoodbaptist',
  1063: 'wbflivestream',
  1069: 'adatariel',
  1070: 'cathedralofhigherpraise',
  1071: 'kaleotulsa',
  1072: 'firstassemblyofgod',
  1074: 'newarkbasilica',
  1075: '1075-test-client-eng-12',
  1076: 'test',
  1078: 'davidlabkovskiproject',
  1079: 'icdurham',
  1082: 'cogs',
  1083: 'GraceCovenant',
  1084: 'bryanentertainment',
  1087: '1087-Natalia-Test',
  1089: '1089-ncfc-of-chattanooga',
  1090: 'LCVGS',
  1091: 'connectionlife',
  1092: 'cedarbend',
  1094: 'christepiscopal',
  1095: 'nhm',
  1097: 'newlifecommunitychurchnazarene',
  1098: 'newlifela',
  1099: '1099-Shiloh-Missionary-Baptist-Church-of-Chicago',
  1101: 'thewaychurchrochester',
  1102: '1stchurch',
  1104: 'springfieldarts',
  1106: '1106-anshe-emeth-memorial-temple',
  1109: 'eastchesterchurch',
  1110: 'gracepointe',
  1113: 'hopi',
  1115: 'greaterwaltownunitedholychurch',
  1117: 'livinghope',
  1118: '1118-mt-calvary-madison-church',
  1119: '1119-the-tabernacle',
  1120: 'antiochbaptistchurch',
  1121: 'fpcsantamonica',
  1124: '1124-iotievo',
  1126: 'faith4lifedallas',
  1127: 'saintpaulsepiscopal',
  1128: 'familylifecenter',
  1129: 'embracechurch',
  1133: 'namastecenterforspiritualliving',
  1134: 'indianapolishebrewcongregation',
  1135: 'bethor',
  1137: '1137-rishis-test-organization-name',
  1142: 'livinglifechurch',
  1143: 'edgecommunity',
  1144: 'universitysynagogue',
  1145: 'c4gd',
  1147: '1147-apple-inc',
  1148: 'FirstUMCModesto',
  1149: 'aliyah',
  1150: '1150-bell-tower-funeral-home',
  1154: 'cka',
  1155: 'bethelknoxville',
  1156: 'templesinaiofroslyn',
  1158: 'stpaulslutheran',
  1159: '1159-mt-calvary-holy-church',
  1160: 'ramatzion',
  1161: 'mtndchurch',
  1164: 'northeastbaptistchurch',
  1166: '1166-temple-sinai-dresher',
  1173: '1173-u-s',
  1177: 'firstsebring',
  1178: 'c3church',
  1181: 'biggreenchurch',
  1182: 'hillsidememorial',
  1184: 'urbanfaith',
  1185: 'wpc',
  1186: '1186-cary-new-user',
  1187: '1187-cary-new-user-2',
  1188: '1188-noahs-ach-organization',
  1189: 'historicspringfieldbaptist',
  1190: '1190-hickory-ridge-community-church',
  1193: 'Dmitriy',
  1197: 'VirginiaHighlandChurch',
  1202: 'johnknoxchurch',
  1204: 'templeisaiahlexington',
  1211: 'templeshalomdallas',
  1212: 'faithchristian',
  1214: 'bethel',
  1216: 'GGIMinistries',
  1217: 'villageoflosranchos',
  1218: 'MtOlivet',
  1220: 'rtfh',
  1221: '1221-beth-el-congregation-baltimore',
  1223: 'cityoffaith',
  1224: 'elimchurch',
  1227: '1227-The-Arts-Campus-at-Willits-TACAW',
  1236: 'corpuschristicatholicchurch',
  1237: 'barnerttemple',
  1238: 'ohavay-zion-synagogue',
  1246: '1246-st-olaf-lutheran-church',
  1249: 'solidrock',
  1250: '1250-clear-creek-m-b-church',
  1254: 'desertheritagechurch',
  1258: 'opendoorchristianchurch',
  1260: 'inspirationalbiblechurch',
  1268: 'uulafun',
  1294: 'HighlandsUMC',
  1295: 'TMPC4LIFE',
  1296: 'citychurchsd',
  1306: 'beth-chayim-chadashim',
  1307: 'graceblueridge',
  1312: 'pilgrimcongregationalchurch',
  1327: 'plcsuperior',
  1329: 'gloriadeinorthbrook',
  1354: 'lbt',
  1372: 'admin',
  1382: '1382-Troy-First-Baptist-Church',
  1389: 'stlukesbethesda',
  1390: '1390-Belmont-Heights-UMC',
  1392: 'llfc',
  1393: '1393-United-Baptist-Church',
  1395: 'repairerschurch',
  1396: 'PalmHarvest',
  1397: 'bethelsp',
  1398: 'churchinaurora',
  1413: 'Adath',
  1414: '1414-Congregation-Beth-Ohr',
  1425: 'eckankar-colorado',
  1429: '1429-St-Stephen-and-the-Incarnation-Episcopal-Church',
  1430: '1430-First-United-Methodist-Church-of-Clewiston-FL',
  1432: '1432-Tifereth-Israel-San-Diego',
  1433: 'assemble',
  1453: 'SOLLC',
  1455: 'grace380',
  1459: 'tbany',
  1461: '1461-Tennessee-Valley-Unitarian-Universalist-Church',
  1474: '1474-The-Streams-Church',
  1483: '1483-St-Paul-United-Methodist-Church',
  1484: '1484-Hope-Church',
  1485: 'Thetemplejax',
  1486: '1486-Temple-Shalom',
  1487: 'TempleIsaiahofGreatNeck',
  1490: 'LCU',
  1491: '1491-Union-Grace-Church',
  1502: '1502-The-Gathering-Church',
  1503: 'tilb',
  1514: 'wpcwestlake',
  1519: 'St-Peters-by-the-Sea',
  1525: 'product',
  1532: 'highviewcf',
  1547: '1547-Bethel-Lutheran-Church',
  1556: 'DelAve',
  1567: '1567-Iglesia-Pentecostal-Roca-de-Salvacion',
  1574: '1574-First-Baptist-Church-Gilbert-LA',
  1577: '1577-Hope-for-You-Family-Life-and-Worship-Center',
  1586: '1586-Rishi-Kumar-Test',
  1597: 'riverfront',
  1613: 'GNC',
  1614: 'gromaneden',
  1618: 'livecontroldemo',
  1619: '1619-Kim-Scott-Ministries',
  1622: '1622-House-of-Worship',
  1625: '1625-CHORALE-Ministries-Fellowship-Center',
  1632: 'mc2innovations',
  1637: '1637-Pine-Street-Presbyterian-Church',
  1638: '1638-Williams-Chapel-Baptist-Church',
  1640: 'Church-Web-Player',
  1646: '1646-Cunningham-Chapel',
  1647: '1647-Bhakta-and-Agarawal-Wedding',
  1649: '1649-Moore-Cortner-Funeral-Home',
  1653: 'donaldjordanmemorialchapel',
  1656: '1656-St-Marks-In-The-Valley-Episcopal-church',
  1657: 'launchhouse',
  1665: 'zrucc',
  1667: '1667-Malibu-Pacific',
  1677: 'hummelfuneralhomes',
  1679: '1679-Conway-Avenue-Baptist-Church',
  1680: 'carnesfuneralhome',
  1681: 'hautfuneralhome',
  1683: '1683-Bethel-AME-Church-of-Fontana',
  1684: 'mooresfuneralhome',
  1685: 'vancebrooksfuneralhome',
  1693: '1693-Wonderly-Horvath-Hanes-Funeral-Home-and-Crematory',
  1694: 'glueckertfuneralhome',
  1698: 'storkefuneralhome',
  1703: '1703-Word-of-God-Christian-Ministries',
  1704: '1704-Calvary-Church',
  1706: '1706-St-Marks-UMC',
  1707: 'johnpfeeney',
  1710: 'sunsetfuneralhomes',
  1711: 'allendave',
  1712: 'mililanimemorial',
  1713: 'henryfh',
  1714: 'First-Christian-Church-Wilmington-Ohio',
  1715: '1715-Green-Mountain-United-Methodist-Church',
  1718: '1718-Forestdale-Community-Church',
  1734: '1734-CrossView-Church',
  1735: 'bluenote',
  1737: 'launchhousenyc',
  1739: 'MyersMortuary',
  1743: '1743-Elder-Tree',
  1744: 'wework',
  1745: '1745-Williams-Funeral-Home',
  1749: '1749-St-Philips-Lutheran-Church',
  1751: '1751-Medford-Congregational-UCC',
  1752: '1752-Gentry-Smith-Funeral-Home',
  1753: 'marchfuneralhomes',
  1766: '1766-Woodlawn-Faith',
  1768: 'mannslonakerfuneralhome',
  1779: 'kayeplayhouse',
  1787: 'First-Christian-Church-of-Topeka',
  1798: '1798-Jesus-People-Proclaim-International',
  1799: 'TBHLA',
  1801: '1801-OConnor-Funeral-Home-and-Crematory',
  1802: 'Faith-Presbyterian-Church-Austin-TX',
  1803: '1803-Flymachine',
  1805: 'Lambert-Funeral-Home-and-Crematory',
  1806: '1806-Gospel-Outreach-Community-Church',
  1807: 'pilatesandor',
  1811: '1811-First-United-Methodist-Church-Georgetown-TX',
  1812: 'VAC',
  1814: '1814-D-W-Swick-Funeral-Home',
  1815: '1815-Columbia-University-Teachers-College',
  1825: 'True-Light-International',
  1827: '1827-Giddens-Memorial-Chapel',
  1835: 'CGTV',
  1845: '1845-Vondel-L-Smith-and-Son-Mortuary-Inc',
  1847: '1847-Temple-Sinai-Oakland',
  1848: 'CCLF',
  1859: 'heartland',
  1862: 'Temple-Beth-Miriam',
  1869: '1869-Conner-and-Koch-Funeral-Home',
  1879: '1879-PURE-Theatre',
  1890: 'UCCMEDFIELD',
  1907: '1907-Believers-Church-of-Kingsport',
  1908: '1908-Valley-Beth-Shalom',
  1910: '1910-Folsom-Hotel',
  1928: 'streamingsuites',
  1931: 'Standard-Web-Player',
  1933: 'CalvaryPlainfield',
  1936: 'sunsetfuneralhome',
  1939: 'daoplanet',
  1940: '1940-St-James-AME-Church',
  1941: 'FairmountTemple',
  1945: 'resonanceevents',
  1971: '1971-First-Baptist-Church-of-Badin',
  1974: 'ThompsonHallandJordanFuneralHome',
  1975: 'excelchurch',
  1977: '1977-Catholic-Funeral-and-Cemetery-Services',
  1985: 'bcs',
  2010: 'ststephensrochester',
  2012: 'papermill',
  2022: 'TheoriaFoundation',
  2036: 'lcdemo',
  2041: 'GuidingStarMBC',
  2053: 'mccartychurch',
  2066: 'tbam',
  2090: 'First-Baptist-Church-Wimberley',
  2092: '2092-Congregation-Beth-El-Voorhees',
  2103: 'CWR',
  2129: 'Stpeter',
  2130: 'forestlawn',
  2131: '2131-Broadmoor-Methodist-Church',
  2140: 'springmountains',
  2210: 'douglassandzook',
  2299: '2299-Spring-Grove-Funeral-Home-Main',
  2315: '2315-DDT',
  2333: 'sholom',
  2336: '2336-Community-Church-of-Glen-Rock',
  2352: 'Temple-Ahavat-Shalom',
  2376: 'CKANJ',
  2378: '2378-Clifton-Park-Baptist-Church',
  2384: 'nmzbconline',
  2389: 'templejeremiah',
  2419: '2419-LC-Finance-Test-Account',
  2440: 'Sinaimke',
  2448: '2448-Jesuss-Comedy-Club',
  2454: 'BridgeChurchNYC',
  2460: '2460-Temple-Adath-Israel-Lexington',
  2466: '2466-Evans-Mortuary',
  2480: 'unicornslive',
  2486: 'johnsonfh',
  2489: 'HeritagePointe',
  2492: 'BEZ',
  2530: 'testToSave',
  2578: '2578-LiveControl-Content',
  2582: '2582-LiveControl-Content',
  2584: '2584-Deeep-Data-Technologies',
  2649: 'tbsroslyn',
  2652: '2652-Home',
  2654: '2654-St-Andrews-Presbyterian-Church',
  2684: 'mountauburn',
  2688: 'GromanEdenMortuary',
  2708: 'ccmlosangeles',
  2711: 'ogcnj',
  2723: 'congregationshirhadash',
  2727: '2727-Nefesh-Los-Angeles',
  2773: 'Mount-Sinai-Memorial-Parks-and-Mortuaries',
  2775: 'JFH',
  2875: 'ParchmentUnitedMethodist',
  2885: 'interfaithfunerals',
  2900: 'sccfa',
  3258: 'ptzoptics',
  3276: '3276-Brotherhood-Synagogue',
  3554: '3554-shineily',
  3618: 'revel-supper-club',
  3631: 'public-theater',
  3634: 'stephenson-gaskin',
  3642: 'bentley-funeral-home',
  3644: 'USSB',
  3655: 'soliefunerals',
  3661: 'The-Borough-of-Glen-Rock',
  3675: 'McLaurin-Funeral-Home-and-Pinecrest-Memorial-Park',
  3677: 'Beck-Funeral-Home',
  3680: 'Saddleback-Chapel',
  3684: 'cfcssacramento',
  3686: 'thevineconnect',
  3688: 'Hanes-Lineberry-Funeral-Home',
  3692: 'Miratsky-Memorial-Parkview',
  3712: 'livestream',
  3722: 'decofamilia',
  3731: '3731-My-Test-Organization',
  3754: '3754-Congregation-Gates-of-Prayer',
  3756: '3756-Thru-The-Bible',
  3760: '3760-Iris-Indie-International',
  3762: 'CityRiseBellaire',
  3776: '3776-Jesus-Estrada',
  3778: '3778-Zendesk-Org',
  3780: '3780-My-Zendesk-Test-Organization',
  3782: '3782-Jesus-Dev-Zendesk-Org',
  3788: '3788-St-Albans-Episcopal-Church',
  3792: '3792-St-Augustine-Catholic-Church',
  3794: '3794-St-Johns-Episcopal-Church',
  3796: '3796-sts-john-and-paul-parish',
  3798: '3798-Saint-James-Episcopal-Church-Danbury',
  3800: '3800-Christ-and-Holy-Trinity-Church',
  3802: 'Calvary-Episcopal-Church',
  3804: '3804-Union-Memorial-Congregational-Church',
  3806: '3806-The-Episcopal-Church-of-the-Incarnation',
  3808: '3808-The-Parish-of-St-Catherine-of-Siena-and-St-Agnes',
  3810: '3810-St-Barnabas-Church',
  3812: '3812-Bradford-Community-Church-Unitarian-Universalist',
  3814: 'ecr',
  3816: '3816-St-George-Episcopal',
  3818: '3818-First-Congregational-Church-of-Darien',
  3820: '3820-Church-of-the-Magdalene',
  3822: '3822-Trinity-Lime-Rock',
  3824: '3824-United-Methodist-Church-of-New-Canaan',
  3826: '3826-Trinity-Episcopal-Church-Collinsville',
  3828: '3828-First-Baptist-Church-of-White-Plains',
  3830: 'StMichaelMemphis',
  3832: '3832-The-Community-Synagogue',
  3834: '3834-First-Presbyterian-Church-of-New-Canaan',
  3836: '3836-The-Church-of-St-Barnabas',
  3838: '3838-St-Johns-Lutheran-Church',
  3840: '3840-St-Francis-Episcopal-Church',
  3842: '3842-St-Johns-Episcopal-Church',
  3844: '3844-Unitarian-Universalist-Church-West',
  3846: '3846-St-Johns-Episcopal-Church-Oakland',
  3848: '3848-SalisburyUCC',
  3850: '3850-First-United-Church-of-Christ',
  3852: '3852-Church-of-the-Holy-Apostles',
  3854: '3854-The-Church-of-the-Ascension',
  3856: '3856-First-Presbyterian-Church',
  3858: '3858-Calvary-Episcopal-Church',
  3860: '3860-St-Marks-Episcopal-Church',
  3862: '3862-St-Matthews-Church',
  3864: '3864-Saint-Lukes-Parish',
  3866: '3866-Christ-Church-Greenwich',
  3868: '3868-Episcopal-Church-of-the-Ascension',
  3893: 'Eastside-Memorial-Park',
  3919: '3919-Snows-Funerals-and-Cremations',
  3932: '3932-organization-test',
  3945: 'OurShirShalom',
  3948: 'bethshalomnb',
  3954: '3954-Saxe-Gotha-Presbyterian-Church',
  3964: '3964-Temple-Sinai-of-Glendale',
  3985: 'templesholomofwestessex',
  3988: '3988-The-Reform-Temple-of-Rockland',
  4008: 'thecatholicmass',
  4042: 'mtsinaimobile',
  4058: 'SJNLivestream',
  4080: 'Berry-Funeral-Home',
  4082: 'Berry-Lynnhurst-Funeral-Home',
  4084: 'Berry-Highland-Memorial'
};
